import { render, staticRenderFns } from "./UpdateEpsUserButton.vue?vue&type=template&id=63a42774&"
import script from "./UpdateEpsUserButton.vue?vue&type=script&lang=js&"
export * from "./UpdateEpsUserButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports